import clsx from 'clsx';
import { string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Icon } from 'components';

import 'assets/styles/components/auth/password-validation.scss';

const PasswordValidation = ({ password }) => {
  const { t } = useTranslation();

  const requirements = [
    { label: t('auth:passwordValidation.numberCharacters'), test: (pwd) => pwd.length >= 8 },
    { label: t('auth:passwordValidation.uppercase'), test: (pwd) => /[A-Z]/.test(pwd) },
    { label: t('auth:passwordValidation.lowercase'), test: (pwd) => /[a-z]/.test(pwd) },
    { label: t('auth:passwordValidation.number'), test: (pwd) => /\d/.test(pwd) },
    { label: t('auth:passwordValidation.specialCharacter'), test: (pwd) => /[@$!%*?&":{}|<>]/.test(pwd) }
  ];

  return (
    <ul className="password-requirements">
      {requirements.map((req, i) => (
        <li key={`requirement-${i}`} className={clsx('requirement-item', { valid: req.test(password) })}>
          <Icon name={req.test(password) ? 'check' : 'xmark'} />
          <span className="ml-2">{req.label}</span>
        </li>
      ))}
    </ul>
  );
};

PasswordValidation.propTypes = {
  password: string.isRequired
};

export default PasswordValidation;
